import React from 'react'

import Link from "./Link"
import Container from './container'

import SparebankstiftelsenLogo from '../../static/images/sparebankstiftelsen-dnb.inline.svg'
import AkerhusFestningLogo from '../../static/images/akerhus-festning.inline.svg'
import SentralenLogo from '../../static/images/sentralen.inline.svg'

import clsx from 'clsx'

const Footer = () => {
  return (
    <footer className={clsx(
       `[--vkd-underline-color:var(--vkd-blue)]`,
       `flex flex-col bg-blue-light pt-[60px]`
    )}>
      <Container className={`mb-[60px]`}>
        <div className={`grid grid-row-2 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px] gap-y-[22px]`}>
          <div className={`col-start-auto row-start-1 md:col-start-1 flex items-end`}>
            <SparebankstiftelsenLogo width="67px" className="w-full" />
          </div>
          <div className={`col-start-auto row-start-3 md:col-start-2 md:row-start-1 flex items-end`}>
            <SentralenLogo width="93px" />
          </div>
          <div className={`col-start-auto row-start-5 md:col-start-1 md:row-start-3 lg:col-start-3 lg:row-start-1 flex items-end`}>
            <AkerhusFestningLogo width="178px" />
          </div>
          <div className={`col-start-auto md:col-start-1 mb-[60px] md:mb-0 lg:col-start-1`}>
            <p className={`text-small`}>Sparebankstiftelsen DNB er en uavhengig stiftelse som gir bidrag til allmennyttige formål. Stiftelsen eier rundt 8 prosent av aksjene i DNB, og utbyttet fra disse aksjene finansierer stiftelsens samfunnsnyttige innsats. </p>
            <p className={`text-small`}><Link to="https://sparebankstiftelsen.no/">Les mer på Sparebankstiftelsen DNBs nettside</Link></p>
          </div>
          <div className={`col-start-auto md:col-start-2 mb-[60px] md:mb-0 lg:col-start-2`}>
            <p className={`text-small`}>Sentralen er et allsidig arrangementshus i Kvadraturen i Oslo sentrum som eies av Sparebankstiftelsen DNB. Sentralen leier ut saler og scener, øvingsrom, produksjonsrom, møterom, studioer og en takterrasse til konserter, forestillinger, festivaler, konferanser og alle andre typer arrangementer.</p>
            <p className={`text-small`}><Link to="https://www.sentralen.no/">Les mer på Sentralens nettside</Link></p>
          </div>
          <div className={`col-start-auto md:col-start-1 lg:col-start-3 mb-[60px] md:mb-0`}>
            <p className={`text-small`}>SAKK - Stiftelsen Akershus festning for Kunst og Kultur - arrangerer Verdens Kuleste Dag sammen med Sparebankstiftelsen DNB og Sentralen. SAKK drifter Karpedammen scene og lager kulturopplevelser for hele familien i historiske omgivelser. På festningen kan du oppleve konserter, teater og festivaler.</p>
            <p className={`text-small`}><Link to="https://karpedammen.no/">Les mer på SAKKs nettside</Link></p>
          </div>
        </div>
      </Container>
      <Container className={`mb-[36px] md:text-center`}>
        <div className={`flex flew-wrap justify-center`}>
          <Link to={`https://www.facebook.com/verdenskulestedag/`} className={`whitespace-nowrap mx-[25px] mb-[25px] md:mb-0 text-base md:text-base-md`}>
            Facebook
          </Link>
          <Link to={`/om-oss/`} className={`whitespace-nowrap mx-[25px] mb-[25px] md:mb-0 text-base md:text-base-md`}>
            Om Oss
          </Link>
        </div>
      </Container>
    </footer>
  )
}

export default Footer
